import React from 'react'

import SvgMultiElements from '../SvgMultiElements'
import shieldIcon from '../../../assets/icons/shield-icon'

export default () => <SvgMultiElements config={shieldIcon} />
